import { useEffect } from 'react';
import { useRouter } from 'next/router';

type RedirectAdapterProps = {
  to: string;
};

const NextRedirect = ({ to }: RedirectAdapterProps) => {
  const router = useRouter();

  useEffect(() => {
    router.push(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

const RedirectAdapter = ({ to }: RedirectAdapterProps) => <NextRedirect to={to} />;

export default RedirectAdapter;
